import { useNavigate } from 'react-router-dom';

export default function FloatingHomeButton() {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate('/')}
            className="fixed bottom-6 left-3 w-14 h-14 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 z-50 group"
            title="Voltar para Apps"
        >
            <i className="ri-apps-2-line text-2xl"></i>
            <span className="absolute left-16 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                Apps
            </span>
        </button>
    );
}
